export const ITEMS_TYPES = {
    GET_ITEMS: 'GET_ITEMS',
    NEW_ITEM: 'NEW_ITEM',
    CLEAN_ITEM: 'CLEAN_ITEM',
    REQUEST_ITEM: 'REQUEST_ITEM',
    REQUEST_ITEM_STATIONS: 'REQUEST_ITEM_STATIONS',
    GET_STATIONS: 'GET_STATIONS',
    EDIT_PRICE: 'EDIT_PRICE',
    OPEN_MODAL_TO_UPDATE: 'OPEN_MODAL_TO_UPDATE',
    REMOVE_ITEMS_TO_UPDATE: 'REMOVE_ITEMS_TO_UPDATE',
    SAVE_ITEMS_TO_UPDATE: 'SAVE_ITEMS_TO_UPDATE',
    CLOSE_EDIT: 'CLOSE_EDIT',
    CLOSE_MODAL_ITEM: 'CLOSE_MODAL_ITEM',
    SET_SNACKBAR: 'SET_SNACKBAR',
    RESET_SNACKBAR:'RESET_SNACKBAR',
    CLEAR_ITEMS_UPDATE: 'CLEAR_ITEMS_UPDATE',
    SET_CONFIG_FILTERED_ITEMS: 'SET_CONFIG_FILTERED_ITEMS',
    SET_CONFIG_PAGE_ITEMS: 'SET_CONFIG_PAGE_ITEMS',
    SET_CONFIG_PAGE_ITEMS_COUNT: 'SET_CONFIG_PAGE_ITEMS_COUNT',
    SET_CONFIG_SORTED_ITEMS : 'SET_CONFIG_SORTED_ITEMS',
    SET_CONFIG_PAGE_ITEM_STATIONS: 'SET_CONFIG_PAGE_ITEM_STATIONS',
    SET_CONFIG_PAGE_ITEM_STATIONS_COUNT: 'SET_CONFIG_PAGE_ITEM_STATIONS_COUNT',
    SET_CONFIG_FILTERED_ITEM_STATIONS: 'SET_CONFIG_FILTERED_ITEM_STATIONS',
    SET_CONFIG_SORTED_ITEM_STATIONS : 'SET_CONFIG_SORTED_ITEM_STATIONS',
    SAVE_ORIGINAL_ITEM_TO_UPDATE: "SAVE_ORIGINAL_ITEM_TO_UPDATE",
}